<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  components: {
    Chart
  },
  data() {
    return {
      drawTiming: null,
      cdata: {
        year: null,
        weekCategory: [],
        maxData: 800,
        weekMaxData: [],
        weekLineData: []
      },
      mockDistance: []
    }
  },
  props: {
    sum: {
      type: Number,
      default: 0
    }
  },
  watch: {
    sum: {
      handler(newData) {
        this.setData(newData)
      },
      immediate: true
    }
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.drawTiming)
  },
  methods: {
    setData(sum) {
      if (this.mockDistance.length === 0) {
        for (let i = 0; i < 7; i++) {
          let distance = Math.round(Math.random() * 100 + 300)
          this.mockDistance.push(i === 6 ? Math.round(distance / 2) : distance) // 初始化模拟值
        }
      }
      this.mockDistance[6] = sum
      // 清空轮询数据
      this.cdata.weekCategory = []
      this.cdata.weekMaxData = []
      this.cdata.weekLineData = []

      let dateBase = new Date()
      this.cdata.year = dateBase.getFullYear()

      // 周数据
      for (let i = 0; i < 7; i++) {
        // 日期
        let date = new Date()
        this.cdata.weekCategory.unshift([date.getMonth() + 1, date.getDate() - i].join('/'))

        // 折线图数据
        this.cdata.weekMaxData.push(this.cdata.maxData)
        this.cdata.weekLineData.push(this.mockDistance[i])
      }
    }
  }
}
</script>
